/**
 * DevExtreme (esm/__internal/ui/list/modules/search.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import SearchBoxController from "../../../ui/collection/search_box_controller";
import TextBox from "../../../ui/text_box/m_text_box";
SearchBoxController.setEditorClass(TextBox);